import { IAdjustmentTypeRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetAdjustmentTypeUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IAdjustmentTypeRepositoryResponse> {
    return this.lookupRepository.getAdjustmentTypes();
  }
}
